import { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

interface ArticleData {
  slug: string;
  title: string;
  excerpt: string;
  readTime: string;
  sections: { heading: string; content: string[] }[];
}

const articlesData: Record<string, ArticleData> = {
  'bezpieczenstwo-kakobuy-spreadsheet': {
    slug: 'bezpieczenstwo-kakobuy-spreadsheet',
    title: 'Czy Kakobuy Spreadsheet jest bezpieczny? Kompletny poradnik bezpieczeństwa 2026',
    excerpt: 'Wszystko co musisz wiedzieć o bezpieczeństwie Kakobuy Spreadsheet. Sprawdzone metody weryfikacji, ochrona danych i bezpieczne płatności.',
    readTime: '6 min',
    sections: [
      {
        heading: 'Wprowadzenie – dlaczego bezpieczeństwo ma znaczenie',
        content: [
          'Zakupy na platformach takich jak Kakobuy stają się coraz popularniejsze wśród polskich klientów. Nic dziwnego — ceny są atrakcyjne, a wybór produktów ogromny. Jednak zanim zaczniesz dodawać produkty do koszyka, warto zastanowić się nad kwestią bezpieczeństwa. Kakobuy Spreadsheet to narzędzie, które znacząco zwiększa bezpieczeństwo zakupów, ale tylko wtedy, gdy wiesz, jak z niego prawidłowo korzystać.',
          'Wielu początkujących użytkowników zastanawia się, czy Kakobuy Spreadsheet jest bezpieczny. Odpowiedź brzmi: tak, pod warunkiem że stosujesz się do kilku podstawowych zasad. W tym artykule wyjaśnimy wszystko krok po kroku.',
        ],
      },
      {
        heading: 'Jak Kakobuy Spreadsheet zwiększa bezpieczeństwo zakupów',
        content: [
          'Główną przewagą Kakobuy Spreadsheet nad samodzielnym przeszukiwaniem platform jest dostęp do zweryfikowanych informacji. Arkusz zawiera produkty, które zostały już sprawdzone przez innych użytkowników — wraz ze zdjęciami QC, opiniami i ocenami. To radykalnie zmniejsza ryzyko zakupu produktu niskiej jakości.',
          'Dodatkowo, korzystając z arkusza, nie musisz klikać w podejrzane linki ani odwiedzać nieznanych stron. Wszystkie linki w arkuszu prowadzą do sprawdzonych ofert na oficjalnych platformach.',
        ],
      },
      {
        heading: 'Zdjęcia QC – Twój najważniejszy sprzymierzeniec',
        content: [
          'Zdjęcia QC (Quality Control) to fotografie rzeczywistego produktu wykonane przed wysyłką. Są one absolutnie kluczowe dla bezpieczeństwa zakupów. Przed zatwierdzeniem zamówienia zawsze dokładnie analizuj zdjęcia QC — sprawdź szwy, logo, kolory i ogólny wygląd produktu. Jeśli coś wydaje się nie tak, masz prawo poprosić o wymianę lub zwrot.',
          'Kakobuy Spreadsheet często zawiera informacje o tym, które produkty mają dostępne zdjęcia QC i jak je interpretować. To ogromne ułatwienie, szczególnie dla nowych użytkowników.',
        ],
      },
      {
        heading: 'Ochrona danych osobowych i płatności',
        content: [
          'Warto podkreślić, że Kakobuy Spreadsheet nie przechowuje żadnych danych płatniczych użytkowników. Arkusz pełni wyłącznie funkcję informacyjną — pokazuje produkty, linki i kategorie. Same transakcje odbywają się bezpośrednio na platformie zakupowej, która stosuje własne zabezpieczenia.',
          'Zawsze korzystaj z oficjalnych metod płatności oferowanych przez platformę. Unikaj bezpośrednich przelewów do sprzedawców i nigdy nie udostępniaj swoich danych logowania osobom trzecim.',
        ],
      },
      {
        heading: 'Podsumowanie – bezpieczne zakupy z Kakobuy Spreadsheet',
        content: [
          'Kakobuy Spreadsheet to bezpieczne narzędzie, które przy prawidłowym użytkowaniu znacząco zmniejsza ryzyko zakupowe. Pamiętaj o sprawdzaniu zdjęć QC, czytaniu opinii i korzystaniu z oficjalnych metod płatności. Stosując się do tych zasad, możesz cieszyć się udanymi zakupami bez niepotrzebnego stresu.',
        ],
      },
    ],
  },
  'wysylka-kakobuy-do-polski': {
    slug: 'wysylka-kakobuy-do-polski',
    title: 'Wysyłka Kakobuy do Polski – wszystko co musisz wiedzieć o dostawie i cłach',
    excerpt: 'Kompletny przewodnik po wysyłce Kakobuy Spreadsheet do Polski. Czasy dostawy, opłaty celne, śledzenie przesyłek i porady praktyczne.',
    readTime: '7 min',
    sections: [
      {
        heading: 'Jak działa wysyłka Kakobuy do Polski',
        content: [
          'Zamawianie produktów przez platformy współpracujące z Kakobuy i wysyłka do Polski to proces, który może wydawać się skomplikowany, ale w rzeczywistości jest dość prosty. Produkty są wysyłane bezpośrednio z magazynów w Chinach do Twojego adresu w Polsce. Cały proces trwa zazwyczaj od 10 do 25 dni roboczych, w zależności od wybranej metody wysyłki.',
          'Kakobuy Spreadsheet pomaga w wyborze odpowiedniej metody wysyłki, ponieważ zawiera informacje o dostępnych opcjach dla każdego produktu. Dzięki temu możesz świadomie wybrać między szybszą, droższą przesyłką a wolniejszą, ale tańszą alternatywą.',
        ],
      },
      {
        heading: 'Dostępne metody wysyłki i ich koszty',
        content: [
          'Najpopularniejsze metody wysyłki do Polski to standardowa przesyłka pocztowa, przesyłka kurierska oraz opcje premium oferowane przez platformę. Każda z nich ma swoje zalety i wady. Przesyłka standardowa jest najtańsza, ale trwa najdłużej. Kurierzy są szybsi i oferują śledzenie przesyłki, ale kosztują więcej.',
        ],
      },
      {
        heading: 'Opłaty celne i VAT – co musisz wiedzieć',
        content: [
          'Przy zamówieniach z Chin do Polski mogą wystąpić dodatkowe opłaty celne i VAT. W 2026 roku zasady są następujące: dla przesyłek o wartości do 150 EUR nie płacisz cła, ale musisz uiścić VAT. Powyżej 150 EUR naliczane jest zarówno cło, jak i VAT. Kakobuy Spreadsheet często zawiera informacje o deklarowanej wartości, co pomaga oszacować koszty.',
        ],
      },
      {
        heading: 'Śledzenie przesyłki i co robić w razie problemów',
        content: [
          'Większość metod wysyłki oferuje numer śledzenia, który pozwala monitorować drogę paczki od nadania do dostarczenia. W przypadku zagubienia lub uszkodzenia przesyłki, platformy zazwyczaj oferują ochronę kupującego i możliwość uzyskania zwrotu.',
        ],
      },
    ],
  },
  'jak-zaczac-z-kakobuy-spreadsheet': {
    slug: 'jak-zaczac-z-kakobuy-spreadsheet',
    title: 'Jak zacząć z Kakobuy Spreadsheet? Poradnik dla początkujących krok po kroku',
    excerpt: 'Pierwsze kroki z Kakobuy Spreadsheet. Od rejestracji po pierwszy zakup.',
    readTime: '8 min',
    sections: [
      {
        heading: 'Kakobuy Spreadsheet dla początkujących – od czego zacząć',
        content: [
          'Rozpoczęcie przygody z Kakobuy Spreadsheet jest prostsze niż myślisz. Nie potrzebujesz specjalistycznej wiedzy ani doświadczenia w zakupach z Chin. Wystarczy kilka minut, aby zapoznać się z podstawami i zacząć efektywnie korzystać z arkusza.',
        ],
      },
      {
        heading: 'Krok 1 – Zapoznaj się ze strukturą arkusza',
        content: [
          'Kakobuy Spreadsheet jest podzielony na kategorie produktów, co ułatwia nawigację. Każda kategoria zawiera listę produktów z podstawowymi informacjami: nazwą, ceną, oceną i linkiem. Poświęć chwilę na przejrzenie dostępnych kategorii, aby zrozumieć, co jest dostępne.',
        ],
      },
      {
        heading: 'Krok 2 – Wybierz interesującą Cię kategorię',
        content: [
          'Zdecyduj, co chcesz kupić — buty, odzież, akcesoria? Wybierz odpowiednią kategorię i przejrzyj dostępne produkty. Zwróć uwagę na oceny i opinie innych użytkowników.',
        ],
      },
      {
        heading: 'Krok 3 – Sprawdź zdjęcia QC i opinie',
        content: [
          'Przed podjęciem decyzji o zakupie koniecznie sprawdź zdjęcia QC, jeśli są dostępne. Porównaj je ze zdjęciami produktu na platformie. Przeczytaj też opinie innych użytkowników.',
        ],
      },
      {
        heading: 'Krok 4 – Dokonaj zakupu przez platformę',
        content: [
          'Gdy jesteś już pewny swojego wyboru, kliknij w link prowadzący do platformy i dokonaj zakupu. Pamiętaj o sprawdzeniu rozmiaru, koloru i innych opcji przed finalizacją zamówienia.',
        ],
      },
    ],
  },
  'najlepsze-produkty-kakobuy-spreadsheet': {
    slug: 'najlepsze-produkty-kakobuy-spreadsheet',
    title: 'Najlepsze produkty w Kakobuy Spreadsheet – top 10 hitów zakupowych 2026',
    excerpt: 'Ranking najlepszych produktów z Kakobuy Spreadsheet. Sprawdzone hity i bezpośrednie linki.',
    readTime: '7 min',
    sections: [
      {
        heading: 'Top 10 produktów, które podbijają Kakobuy Spreadsheet',
        content: [
          'Każdego miesiąca użytkownicy Kakobuy Spreadsheet odkrywają nowe perełki zakupowe. Zebraliśmy dla Ciebie listę 10 najlepszych produktów, które cieszą się największym zainteresowaniem w 2026 roku. Każdy z nich został pozytywnie oceniony przez społeczność.',
        ],
      },
      {
        heading: 'Sneakersy – numer jeden w każdym zestawieniu',
        content: [
          'Nie jest zaskoczeniem, że sneakersy dominują w zestawieniach popularności. Kakobuy Spreadsheet zawiera setki modeli — od klasycznych białych sneakersów po limitowane edycje inspirowane największymi markami.',
        ],
      },
      {
        heading: 'Bluzy i odzież streetwear – hit sezonu',
        content: [
          'Streetwear to kategoria, która nieustannie rośnie. Bluzy z ciekawymi nadrukami, koszulki z oryginalnymi wzorami i kurtki w streetwearowym stylu to produkty, które znajdziesz w czołówce arkusza.',
        ],
      },
      {
        heading: 'Akcesoria – małe rzeczy, duże wrażenie',
        content: [
          'Nie zapominaj o akcesoriach — czapki, paski, torby czy biżuteria to produkty, które często mają najlepszy stosunek jakości do ceny. W arkuszu znajdziesz setki starannie wyselekcjonowanych akcesoriów.',
        ],
      },
    ],
  },
  'kakobuy-spreadsheet-vs-konkurencja': {
    slug: 'kakobuy-spreadsheet-vs-konkurencja',
    title: 'Kakobuy Spreadsheet vs konkurencja – porównanie arkuszy zakupowych 2026',
    excerpt: 'Szczegółowe porównanie Kakobuy Spreadsheet z innymi arkuszami zakupowymi.',
    readTime: '6 min',
    sections: [
      {
        heading: 'Dlaczego warto porównywać arkusze zakupowe',
        content: [
          'Na rynku istnieje wiele arkuszy i list zakupowych, ale nie wszystkie są sobie równe. Kakobuy Spreadsheet wyróżnia się na tle konkurencji pod kilkoma kluczowymi względami: aktualnością danych, jakością zdjęć QC i przejrzystością kategorii.',
        ],
      },
      {
        heading: 'Aktualność i częstotliwość aktualizacji',
        content: [
          'Kakobuy Spreadsheet jest aktualizowany regularnie — często codziennie. Wiele konkurencyjnych arkuszy nie jest aktualizowanych od tygodni lub miesięcy, co oznacza, że linki mogą być nieaktywne, a ceny nieaktualne.',
        ],
      },
      {
        heading: 'Jakość informacji i zdjęć QC',
        content: [
          'Zdjęcia QC to kluczowy element każdego arkusza. Kakobuy Spreadsheet zawiera szczegółowe fotografie kontrolne dla większości produktów. Konkurencyjne arkusze często pomijają ten element lub oferują zdjęcia niskiej jakości.',
        ],
      },
      {
        heading: 'Dostępność dla polskich klientów',
        content: [
          'Nie wszystkie arkusze są przyjazne dla polskich użytkowników. Kakobuy Spreadsheet zawiera informacje o wysyłce do Polski, cłach i procedurach, co czyni go najlepszym wyborem dla klientów z Polski.',
        ],
      },
    ],
  },
  'kakobuy-spreadsheet-buty-przewodnik': {
    slug: 'kakobuy-spreadsheet-buty-przewodnik',
    title: 'Kakobuy Spreadsheet Buty – kompletny przewodnik po sneakersach i nie tylko',
    excerpt: 'Wszystko o butach w Kakobuy Spreadsheet. Najlepsze sneakersy i porady dotyczące rozmiarów.',
    readTime: '7 min',
    sections: [
      {
        heading: 'Buty w Kakobuy Spreadsheet – dlaczego to najpopularniejsza kategoria',
        content: [
          'Kategoria butów w Kakobuy Spreadsheet to absolutny hit. Sneakersy, buty sportowe, eleganckie — znajdziesz tutaj wszystko. Popularność tej kategorii wynika z doskonałego stosunku jakości do ceny oraz ogromnego wyboru modeli.',
        ],
      },
      {
        heading: 'Jak wybrać odpowiedni rozmiar – poradnik',
        content: [
          'Azjatyckie rozmiary butów różnią się od europejskich. W arkuszu znajdziesz szczegółowe tabele rozmiarów i wskazówki, jak dobrać odpowiedni rozmiar. Zawsze mierz stopę i porównuj z tabelą — to podstawa udanego zakupu.',
        ],
      },
      {
        heading: 'Najlepsze modele sneakersów w arkuszu',
        content: [
          'W arkuszu znajdziesz setki modeli sneakersów — od klasycznych białych, przez kolorowe wzory, po limitowane edycje. Każdy model jest opisany wraz z ocenami użytkowników i zdjęciami QC.',
        ],
      },
    ],
  },
  'kakobuy-spreadsheet-moda-streetwear': {
    slug: 'kakobuy-spreadsheet-moda-streetwear',
    title: 'Kakobuy Spreadsheet Moda i Streetwear – co warto kupić w 2026 roku',
    excerpt: 'Przegląd najlepszych ubrań streetwear w Kakobuy Spreadsheet. Bluzy, koszulki, kurtki.',
    readTime: '6 min',
    sections: [
      {
        heading: 'Streetwear w Kakobuy Spreadsheet – przegląd kategorii',
        content: [
          'Moda streetwear to jedna z najszybciej rosnących kategorii w Kakobuy Spreadsheet. Bluzy z kapturem, oversize\'owe koszulki, kurtki bomberki i joggersy — wszystko to znajdziesz w arkuszu, wraz ze zdjęciami QC i opiniami.',
        ],
      },
      {
        heading: 'Bluzy i hoodie – must-have każdej garderoby',
        content: [
          'Bluzy z kapturem to najczęściej kupowany element odzieży w arkuszu. Wysoka jakość materiałów, ciekawe nadruki i atrakcyjne ceny sprawiają, że są one hitem wśród polskich klientów.',
        ],
      },
      {
        heading: 'Koszulki z nadrukami – wyraź swój styl',
        content: [
          'Koszulki z oryginalnymi grafikami i nadrukami to kolejna kategoria, która cieszy się ogromną popularnością. W arkuszu znajdziesz setki wzorów, od minimalistycznych po odważne, artystyczne projekty.',
        ],
      },
      {
        heading: 'Akcesoria streetwear – dopełnij swój look',
        content: [
          'Nie zapominaj o dodatkach — czapki z daszkiem, nerki, skarpetki i biżuteria to elementy, które dopełniają streetwearowy look. W arkuszu znajdziesz je w przystępnych cenach.',
        ],
      },
    ],
  },
  'kakobuy-spreadsheet-porady-zakupowe': {
    slug: 'kakobuy-spreadsheet-porady-zakupowe',
    title: 'Kakobuy Spreadsheet – 10 praktycznych porad zakupowych które musisz znać',
    excerpt: 'Najlepsze porady i triki zakupowe dla użytkowników Kakobuy Spreadsheet.',
    readTime: '5 min',
    sections: [
      {
        heading: '10 porad, które zmienią Twoje podejście do zakupów',
        content: [
          'Korzystanie z Kakobuy Spreadsheet może być jeszcze bardziej efektywne, jeśli zastosujesz kilka sprawdzonych trików. Oto 10 praktycznych porad, które pomogą Ci zaoszczędzić czas i pieniądze.',
        ],
      },
      {
        heading: 'Porównuj ceny i jakość między kategoriami',
        content: [
          'Nie ograniczaj się do jednej kategorii. Często podobne produkty są dostępne w różnych kategoriach w różnych cenach. Warto poświęcić chwilę na porównanie.',
        ],
      },
      {
        heading: 'Czytaj opinie innych użytkowników',
        content: [
          'Społeczność Kakobuy jest bardzo aktywna i chętnie dzieli się doświadczeniami. Przed zakupem zawsze sprawdź opinie — mogą one uchronić Cię przed nietrafionym zakupem.',
        ],
      },
      {
        heading: 'Korzystaj z listy życzeń i planuj zakupy',
        content: [
          'Zamiast kupować impulsywnie, twórz listę życzeń i planuj zakupy z wyprzedzeniem. Dzięki temu unikniesz niepotrzebnych wydatków i podejmiesz lepsze decyzje.',
        ],
      },
    ],
  },
  'kakobuy-spreadsheet-faq': {
    slug: 'kakobuy-spreadsheet-faq',
    title: 'Kakobuy Spreadsheet FAQ – najczęściej zadawane pytania i odpowiedzi',
    excerpt: 'Kompletne FAQ Kakobuy Spreadsheet. Odpowiedzi na najczęściej zadawane pytania.',
    readTime: '5 min',
    sections: [
      {
        heading: 'Najczęściej zadawane pytania',
        content: [
          'Zebraliśmy najczęściej zadawane pytania dotyczące Kakobuy Spreadsheet. Jeśli nie znalazłeś odpowiedzi na swoje pytanie, zapraszamy do kontaktu.',
        ],
      },
      {
        heading: 'Czy Kakobuy Spreadsheet jest darmowy?',
        content: [
          'Tak, dostęp do arkusza i wszystkich list produktów jest całkowicie bezpłatny. Nie pobieramy żadnych opłat od użytkowników.',
        ],
      },
      {
        heading: 'Jak często arkusz jest aktualizowany?',
        content: [
          'Aktualizacje odbywają się regularnie — zazwyczaj codziennie lub co kilka dni, w zależności od dostępności nowych produktów i zmian na platformie.',
        ],
      },
      {
        heading: 'Czy mogę zwrócić produkt, jeśli nie spełnia oczekiwań?',
        content: [
          'Zasady zwrotów zależą od platformy, na której dokonujesz zakupu. Większość platform oferuje ochronę kupującego i możliwość zwrotu w określonym czasie.',
        ],
      },
    ],
  },
};

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();

  const article = slug ? articlesData[slug] : null;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!article) {
    return (
      <>
        <Navbar />
        <main className="pt-20">
          <div className="w-full px-4 md:px-6 py-20 text-center">
            <h1 className="text-2xl font-heading text-foreground-950 mb-4">Artykuł nie został znaleziony</h1>
            <Link to="/" className="text-primary-500 hover:text-primary-600 cursor-pointer">Wróć do strony głównej</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const mainSiteUrl = 'https://kaspreadsheet.com';
  const canonicalUrl = `https://kakobuypolska.cfd/artykul/${article.slug}`;

  const faqItems = article.sections.map((s, i) => ({
    question: s.heading,
    answer: s.content.join(' '),
  }));

  const articleJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    url: canonicalUrl,
    inLanguage: 'pl-PL',
    datePublished: '2026-07-01',
    dateModified: '2026-07-21',
    author: { '@type': 'Organization', name: 'Kakobuy Spreadsheet Polska' },
    publisher: { '@type': 'Organization', name: 'Kakobuy Spreadsheet Polska', url: 'https://kakobuypolska.cfd/' },
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: { '@type': 'Answer', text: item.answer },
    })),
  };

  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Strona główna', item: 'https://kakobuypolska.cfd/' },
      { '@type': 'ListItem', position: 2, name: article.title, item: canonicalUrl },
    ],
  };

  return (
    <>
      <Navbar />
      <main className="pt-20">
        <article className="w-full px-4 md:px-6 py-8 md:py-12">
          <div className="max-w-3xl mx-auto">
            <nav className="mb-6 text-xs md:text-sm text-foreground-500 flex flex-wrap items-center gap-1" aria-label="Breadcrumb">
              <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">Strona główna</Link>
              <span className="mx-1">/</span>
              <span className="text-foreground-700">{article.title}</span>
            </nav>

            <header className="mb-8">
              <h1 className="text-xl md:text-3xl lg:text-4xl font-heading text-foreground-950 leading-tight mb-4">
                {article.title}
              </h1>
              <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500 mb-4">
                <span className="flex items-center gap-1">
                  <i className="ri-calendar-line"></i> Aktualizacja: Lipiec 2026
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-time-line"></i> Czas czytania: {article.readTime}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-user-line"></i> Autor: Zespół Kakobuy Spreadsheet Polska
                </span>
              </div>
            </header>

            <div className="text-sm md:text-base text-foreground-700 leading-relaxed space-y-5">
              <p className="text-base md:text-lg text-foreground-800 font-medium">
                {article.excerpt}
              </p>

              <div className="bg-primary-50/70 border border-primary-200/70 rounded-lg p-5 md:p-6 my-8">
                <p className="text-sm md:text-base text-foreground-800 font-medium mb-3">
                  Chcesz od razu przejść do list produktów?
                </p>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-full text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-200"
                >
                  Otwórz Kakobuy Spreadsheet
                  <i className="ri-arrow-right-up-line"></i>
                </a>
              </div>

              {article.sections.map((section, idx) => (
                <div key={idx}>
                  <h2 className="text-lg md:text-2xl font-heading text-foreground-950 mt-10 mb-3">
                    {section.heading}
                  </h2>
                  {section.content.map((paragraph, pIdx) => (
                    <p key={pIdx} className="mb-3">
                      {paragraph}
                    </p>
                  ))}
                </div>
              ))}

              <div className="bg-accent-50/70 border border-accent-200/70 rounded-lg p-5 md:p-6 my-8 text-center">
                <h3 className="text-base md:text-lg font-heading text-foreground-950 mb-2">
                  Chcesz dowiedzieć się więcej?
                </h3>
                <p className="text-sm text-foreground-600 mb-4">
                  Wróć do strony głównej i wybierz interesującą Cię kategorię produktów.
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                  <Link
                    to="/"
                    className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-50 font-semibold rounded-full text-sm whitespace-nowrap cursor-pointer hover:bg-accent-600 transition-all duration-200"
                  >
                    Powrót do strony głównej
                    <i className="ri-home-line"></i>
                  </Link>
                  <a
                    href={mainSiteUrl}
                    target="_blank"
                    rel="noopener nofollow"
                    className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-full text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-200"
                  >
                    Otwórz Kakobuy Spreadsheet
                    <i className="ri-arrow-right-up-line"></i>
                  </a>
                </div>
              </div>
            </div>

            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{ __html: JSON.stringify(articleJsonLd) }}
            />
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
            />
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJsonLd) }}
            />
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}